import { useState } from "react";
import { siteSettingsUpdate, type SiteSettings, type NowPill } from "@akhshy/types";
import { api } from "../../../lib/api.ts";
import { useForm } from "../../../lib/useForm.ts";
import { FormField } from "../../molecules/FormField.tsx";
import { PillRowsEditor } from "../../molecules/RepeatableRows.tsx";
import { Button } from "../../atoms/Button.tsx";
import { Input } from "../../atoms/Input.tsx";
import { Textarea } from "../../atoms/Textarea.tsx";

export function SettingsForm({ initial }: { initial: SiteSettings }) {
  const { errors, submitting, submit } = useForm(siteSettingsUpdate, "Settings saved");
  const [v, setV] = useState(initial);
  const set = <K extends keyof SiteSettings>(key: K, value: SiteSettings[K]) => setV((p) => ({ ...p, [key]: value }));

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const { updatedAt: _drop, ...patch } = v;
    void submit(patch, async (parsed) => {
      await api.settings.update(parsed);
    });
  };

  const text = (label: string, key: keyof SiteSettings) => (
    <FormField label={label} error={errors[key]}>
      <Input value={String(v[key])} onChange={(e) => set(key, e.target.value as never)} />
    </FormField>
  );

  return (
    <form onSubmit={onSubmit} className="panel" style={{ padding: 24 }}>
      <div className="field-row">
        {text("Eyebrow", "eyebrow")}
        {text("Desk note", "deskNote")}
      </div>
      {text("Headline", "headline")}
      {text("Headline accent", "headlineAccent")}
      <FormField label="Hero subtitle" error={errors["heroSub"]}>
        <Textarea value={v.heroSub} rows={2} onChange={(e) => set("heroSub", e.target.value)} />
      </FormField>
      <FormField label="Now pills" error={errors["nowPills"]}>
        <PillRowsEditor rows={v.nowPills} onChange={(rows) => set("nowPills", rows as NowPill[])} />
      </FormField>
      {text("Portrait URL", "portraitUrl")}
      {text("Portrait caption", "portraitCaption")}
      {text("Footer note", "footerNote")}
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
        <Button type="submit" variant="primary" disabled={submitting}>
          {submitting ? "Saving…" : "Save settings"}
        </Button>
      </div>
    </form>
  );
}
